import { Text } from '@components/primitives/Text'
import {
  isArrivoBioMdd,
  isMindMedGad3,
  isNeurocrineMdd,
  isOtsukaMdd,
  isVistagenPalisade,
} from '@modules/trials/helpers/isHardcodedTrial'
import type { ParsedTimelineAttribute } from './getTimelineValues'

export const TimelineCardCaption = ({
  nctId,
  reporting,
  screening,
  treatment,
}: {
  nctId: string
  reporting: ParsedTimelineAttribute
  screening: ParsedTimelineAttribute
  treatment: ParsedTimelineAttribute
}) => {
  const timelineCardCaption = getCustomTimelineCardCaption({
    nctId,
    reporting,
    screening,
    treatment,
  })

  return (
    <Text
      className='mt-4 border-t border-neutral200 pt-4 text-center text-neutral600'
      styleName='p-small'
    >
      {timelineCardCaption}
    </Text>
  )
}

const getCustomTimelineCardCaption = ({
  nctId,
  reporting,
  screening,
  treatment,
}: {
  nctId: string
  reporting: ParsedTimelineAttribute
  screening: ParsedTimelineAttribute
  treatment: ParsedTimelineAttribute
}) => {
  if (isMindMedGad3(nctId)) {
    return (
      <>
        This study&apos;s timeline: screening for a total of 30 days, Double
        Blind Period for a total of 12 weeks, and an{' '}
        <span className='font-bold'>Open Label Extension</span> for a total of
        56 weeks.
      </>
    )
  } else if (isVistagenPalisade(nctId)) {
    return `This trial's timeline: ${screening.duration} for screening, ${treatment.visitCount} that are ${treatment.duration} apart for treatment, and ${reporting.duration} for reporting. There is also an open label period where patients will have the opportunity to use Fasedienol in everyday life prior to stressful situations or events up to 12 months.`
  } else if (isOtsukaMdd(nctId)) {
    return `This trial's timeline: ${screening.duration} for screening, ${treatment.duration} for study treatment, and ${reporting.duration} for follow up.`
  } else if (isNeurocrineMdd(nctId)) {
    return `This trial's timeline: ${screening.duration} for screening, ${treatment.duration} for treatment, and ${reporting.duration} for follow-up.`
  } else if (isArrivoBioMdd(nctId)) {
    return `This trial's timeline: ${screening.duration} for screening, ${treatment.duration} for study treatment, and ${reporting.duration} for reporting.`
  } else {
    return `This trial's timeline: ${screening.duration} for screening, ${treatment.duration} for treatment, and ${reporting.duration} for reporting.`
  }
}
